import Vue from 'vue';
import router from "@/router/index.js"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);


import {
  library
} from '@fortawesome/fontawesome-svg-core'
import {
  fas
} from '@fortawesome/free-solid-svg-icons'
import {
  far
} from '@fortawesome/free-regular-svg-icons'
import {
  fab
} from '@fortawesome/free-brands-svg-icons'
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome'

library.add(fas, far, fab)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

import VueQrcode from '@chenfengyuan/vue-qrcode';
Vue.component(VueQrcode.name, VueQrcode);

import VueScrollLock from 'vue-scroll-lock'
Vue.use(VueScrollLock)

import '@/assets/css/common.css'
import '@/assets/icofont/icofont.min.css'

import store from "@/vuex/store.js"
import App from '@/router/app.vue';

import "d3-selection-multi"

new Vue({
  el: '#app',
  store,
  router,
  render: h => {
    return h(App)
  },
  template: '<app />'
})

import axios from "axios";
axios.defaults.headers.common['Authorization'] = "JWT " + window.localStorage.token;

// http request 拦截器
axios.interceptors.request.use(
  config => {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    if (window.localStorage.token) {
      config.headers.common['Authorization'] = "JWT " + window.localStorage.token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    switch (error.response.status) {
      case 400:
        store.commit('users/showLoginMessage', '请输入正确的手机号和验证码！');
    }
    return Promise.reject(error.response); // 返回接口返回的错误信息
  }
);

Vue.prototype.$http = axios;